import LandingReveal from '@/modules/Pages/shared/LandingReveal';

type HeroSectionProps = {
  onWaitlistClick: () => void;
};

export default function HeroSection({ onWaitlistClick }: HeroSectionProps) {
  return (
    <section className="landing-glow-hero pt-36 pb-24 px-6 relative overflow-hidden">
      <div className="absolute top-32 right-0 w-[480px] h-[480px] rounded-full pointer-events-none opacity-20 blur-3xl bg-primaryold-400" />

      <div className="max-w-6xl mx-auto grid lg:grid-cols-[1.05fr_0.95fr] gap-14 items-center relative z-10">
        <LandingReveal immediate>
          <p className="landing-section-label mb-5">Early access · B2B SaaS</p>
          <h1 className="landing-headline text-4xl sm:text-5xl lg:text-[3.35rem] font-bold leading-[1.08] mb-6">
            Ever been blindsided by a customer you thought was{' '}
            <span className="text-accent">healthy</span>?
          </h1>
          <p className="landing-prose mb-5 max-w-xl">
            ChurnSignal helps lean CS teams focus their existing capacity where it matters most. Find customers at risk
            earlier, understand why, and know what action to take before they start leaving.
          </p>
          <p className="text-secondary text-lg mb-8 max-w-xl">
            Join the list of teams getting early access to ChurnSignal.
          </p>
          <button
            type="button"
            onClick={onWaitlistClick}
            className="inline-flex px-8 py-4 rounded-lg font-semibold transition-all duration-200 hover:scale-[1.02] active:scale-[0.98]"
            style={{
              backgroundColor: '#fafafa',
              color: '#0e1c2a',
              boxShadow: '0 8px 32px rgba(250, 250, 250, 0.1)',
            }}
          >
            Join the waitlist
          </button>
        </LandingReveal>

        <LandingReveal delayClass="landing-delay-1" className="relative">
          <div className="relative h-[300px] sm:h-[380px]">
            <div className="landing-screenshot-frame absolute top-0 left-0 w-[88%] rounded-xl overflow-hidden bg-dark-gray-b">
              <img
                src="/images/dashboard1.png"
                alt="ChurnSignal dashboard overview"
                className="w-full h-auto object-cover"
              />
            </div>
            <div className="landing-screenshot-frame absolute bottom-0 right-0 w-[72%] rounded-xl overflow-hidden bg-dark-gray-b shadow-2xl">
              <img
                src="/images/actions1.png"
                alt="Risk analysis with recommended actions"
                className="w-full h-auto object-cover"
              />
            </div>
          </div>
        </LandingReveal>
      </div>
    </section>
  );
}
